<template>
    <li class="item">
        <div class="item__title">
            <span class="item__date">{{ dateParser(inspection.startDate) }}</span>
            <span class="item__number">{{ inspection.number }}</span>
        </div>
        <div class="item__info">
            <p v-if="inspection.inspect_type"><b>Вид проверки:</b> {{ inspection.inspect_type }} <span v-if="inspection.verify_type">({{ inspection.verify_type }})</span></p>
            <p v-if="inspection.inspectedCompanyName"><b>Проверяемое подразделение:</b> {{ inspection.inspectedCompanyName }}</p>
            <p v-if="inspection.inspectedCompanyAddress"><b>Адрес:</b> {{ inspection.inspectedCompanyAddress }}</p>
            <p v-if="inspection.inspectingCompanyName"><b>Проверяющий орган:</b> {{ inspection.inspectingCompanyName }}</p>
            <p v-if="inspection.target"><b>Цель проверки:</b> {{ inspection.target }}</p>
            <div v-if="inspection.violations.length" class="violations">
                <p><b>Нарушения:</b></p>
                <ul>
                    <li v-for="(v, i) in inspection.violations" :key="i">
                        <p v-if="v.result"><b>Результаты проверки:</b> {{ v.result }}</p>
                        <p v-if="v.instruction"><b>Предписание:</b> {{ v.instruction }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    props: {
        inspection: Object
    }
}
</script>

<style lang="sass" scoped>
.item
    padding: 15px 10px
    &:not(:last-child)
        border-bottom: 1px solid #ddd
    &__title
        width: 100%
        font-size: 20px
        margin-bottom: 15px
    &__number
        color: #3498db
    &__info
        width: 100%
        p
            margin: 6px 0
            font-size: 14px
        .violations
            ul
                margin: 0
                li
                    padding: 10px 0
</style>